import actions from './actions'
import {RequestService as req} from "../../../services/requestService";
import { Constants } from "../../../config/constants";
import {Auth} from "../../../services/authService";
import {fetchUsers} from "../../userManagement/users/actionCreator";
const {
    fetchAllStudentsAction, fetchMyStudentsAction, fetchMarksEntryStudentsAction, fetchSectionStudentsAction,
    fetchSubjectStudentsAction, fetchSubjectChosenStudentsAction
} = actions;

export const fetchAllStudents = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.STUDENTS}all/students`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchAllStudentsAction(cb)))
    };
};

export const fetchSectionStudents = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.STUDENTS}section/students`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchSectionStudentsAction(cb)))
    };
};

export const fetchSubjectStudents = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.STUDENTS}subject/students`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchSubjectStudentsAction(cb)))
    };
};

export const fetchSubjectChosenStudents = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.STUDENTS}/students/subjects/chosen`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchSubjectChosenStudentsAction(cb)))
    };
};

export const updateStudentFingerprint = (data, action) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.ACADEMIC}student/fingerprint`,
            body: data,
            auth: 'bearer'
        }, async (cb)  => {
            await dispatch(fetchSectionStudents(cb))
            if (action) await action();
        })
    };
};

export const updateStudentCard = (data, action) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.ACADEMIC}student/card`,
            body: data,
            auth: 'bearer'
        }, async (cb)  => {
            await dispatch(fetchSectionStudents(cb))
            if (action) await action();
        })
    };
};

export const updateStudentSMSOff = (data, action) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.ACADEMIC}student/sms/off`,
            body: data,
            auth: 'bearer'
        }, async (cb)  => {
            await dispatch(fetchSectionStudents(cb))
            if (action) await action();
        })
    };
};


export const fetchMyStudents = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.STUDENTS}my/students`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchMyStudentsAction(cb)))
    };
};

export const updateStudentSubjectStatus = (payload, action) => {
    const userInfo = Auth?.getUserInfo();
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.STUDENTS}students/subjects/chosen`,
            body: payload,
            auth: 'bearer'
        }, async (cb)  => {
            await dispatch(fetchMyStudents({teacherId: userInfo?._id}))
            if (action) await action();
        })
    };
};

export const updateSubjectChosenStudentStatus = (payload, action) => {
    const userInfo = Auth?.getUserInfo();
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.STUDENTS}students/subjects/chosen`,
            body: payload,
            auth: 'bearer'
        }, async (cb)  => {
            await dispatch(fetchSubjectChosenStudents({sessionId: payload?.sessionId, classId: payload.classId, sectionId: payload.sectionId, subjectId: payload.subjectId}))
            if (action) await action();
        })
    };
};


export const fetchAllLeftStudents = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.STUDENTS}all/students`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchAllStudentsAction(cb)))
    };
};

export const fetchSectionLeftStudents = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.STUDENTS}section/students`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchSectionStudentsAction(cb)))
    };
};

export const updateSectionStudentSubjectStatus = (payload, filters, action) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.STUDENTS}section/students/subjects/chosen`,
            body: payload,
            auth: 'bearer'
        }, async (cb)  => {
            if (filters) {
                dispatch(fetchSectionStudents({sessionId: filters?.sessionId, classId: filters.classId, sectionId: filters.sectionId}))
            }
            if (action && cb) await action(cb);
            if (action && !cb) await action();
        })
    };
};

export const updateStudentSubjectAllowedStatus = (payload, filters, action) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.STUDENTS}students/subjects/chosen/allowed-status`,
            body: payload,
            auth: 'bearer'
        }, async (cb)  => {
            if (filters) {
                dispatch(fetchSectionStudents({sessionId: filters?.sessionId, classId: filters.classId, sectionId: filters.sectionId}))
            }
            if (action && cb) await action(cb);
        })
    };
};

export const addChosenSubject = (payload, filters, action) => {
    console.log("here hit")
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.STUDENTS}students/subjects/chosen/add-subject`,
            body: payload,
            auth: 'bearer'
        }, async (cb)  => {
            if (filters) {
                dispatch(fetchSectionStudents({sessionId: filters?.sessionId, classId: filters.classId, sectionId: filters.sectionId}))
            }
            if (action && cb) await action(cb);
        })
    };
};

export const dropApproved = (payload, filters, action) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.STUDENTS}students/subjects/chosen/drop-approved`,
            body: payload,
            auth: 'bearer'
        }, async (cb)  => {
            if (filters) {
                dispatch(fetchSectionStudents({sessionId: filters?.sessionId, classId: filters.classId, sectionId: filters.sectionId}))
            }
            if (action && cb) await action(cb);
        })
    };
};

export const removePending = (payload, filters, action) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.STUDENTS}students/subjects/chosen/remove-pending`,
            body: payload,
            auth: 'bearer'
        }, async (cb)  => {
            if (filters) {
                dispatch(fetchSectionStudents({sessionId: filters?.sessionId, classId: filters.classId, sectionId: filters.sectionId}))
            }
            if (action && cb) await action(cb);
        })
    };
};



export const admissionStatusUpdate = (data) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.STUDENTS}all/students/update/status`,
            auth: 'bearer',
            body: data.studentInfo,
        },  async (cb) => {
            if (data.filterInfo.filters.sessionId) {
                dispatch(fetchAllStudents(data.filterInfo.filters))
            }
        })
    };
};

export const candidateNoUpdate = (data) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.STUDENTS}all/students/update/candidate-no`,
            auth: 'bearer',
            body: data.studentInfo,
        },  async (cb) => {
            if (data.filterInfo.filters.sessionId) {
                dispatch(fetchAllStudents(data.filterInfo.filters))
            }
        })
    };
};

export const allowedAttendanceDeadline = (data) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.STUDENTS}all/students/update/date-no`,
            auth: 'bearer',
            body: data.studentInfo,
        },  async (cb) => {
            if (data.filterInfo.filters.sessionId) {
                dispatch(fetchAllStudents(data.filterInfo.filters))
            }
        })
    };
};

export const studentPasswordReset = (data) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.STUDENTS}all/students/reset/password`,
            auth: 'bearer',
            body: data.studentInfo,
        },  async (cb) => {
            if (data.filterInfo.filters.sessionId) {
                dispatch(fetchAllStudents(data.filterInfo.filters))
            }
        })
    };
};

export const accessStatusUpdate = (data) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.STUDENTS}all/students/update/access`,
            auth: 'bearer',
            body: data.studentInfo,
        },  async (cb) => {
            if (data.filterInfo.filters.sessionId) {
                dispatch(fetchAllStudents(data.filterInfo.filters))
            }
        })
    };
};

export const nameUpdate = (data) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.STUDENTS}all/students/update/name`,
            auth: 'bearer',
            body: data.studentInfo,
        },  async (cb) => {
            if (data.filterInfo.filters.sessionId) {
                dispatch(fetchAllStudents(data.filterInfo.filters))
            }
        })
    };
};

export const updatePreHalfYearlyMarks = (data) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.STUDENTS}marks/half-yearly/preMarks/students`,
            auth: 'bearer',
            body: data.studentInfo,
        },  async (cb) => {
            if (data.filterInfo.filters.sessionId) {
                dispatch(fetchAllStudents(data.filterInfo.filters))
            }
        })
    };
};

export const updatePreFinalMarks = (data) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.STUDENTS}marks/final/preMarks/students`,
            auth: 'bearer',
            body: data.studentInfo,
        },  async (cb) => {
            if (data.filterInfo.filters.sessionId) {
                dispatch(fetchAllStudents(data.filterInfo.filters))
            }
        })
    };
};

export const updatePreQuarterMarks = (data) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.STUDENTS}marks/quarter/preMarks/students`,
            auth: 'bearer',
            body: data.studentInfo,
        },  async (cb) => {
            if (data.filterInfo.filters.sessionId) {
                dispatch(fetchAllStudents(data.filterInfo.filters))
            }
        })
    };
};

export const changeStudentSection = (data) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.STUDENTS}change-section/student`,
            auth: 'bearer',
            body: data.studentInfo,
        },  async (cb) => {
            if (data.filterInfo.filters.sessionId) {
                dispatch(fetchAllStudents(data.filterInfo.filters))
            }
        })
    };
};


export const fetchMarksEntryStudents = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.STUDENTS}/marks/entry/students`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchMarksEntryStudentsAction(cb)))
    };
};

export const updateZoomIdStatus = (data, action) => {
    const userInfo = Auth?.getUserInfo();
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.STUDENTS}students/zoom/status`,
            body: data.coordinationValues,
            auth: 'bearer'
        }, async (cb)  => {
            await dispatch(fetchMyStudents({teacherId: userInfo?._id}))
            if (action) await action();
        })
    };
};